import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const errors = {
	state: {
		error : null
	},
	getters: {
		getError : state => state.error,
	},
	actions: {
        eraseError({commit}){
            commit('eraseError');
		},
		setError: ({ commit }, error) => {
			commit('setError', error);
		},
	},
	mutations: {
		setError : (state, error) => {
			state.error = error;
		},
        eraseError : (state, error) => {
			state.error = null;
		}
	}
}

export default errors;



// WEBPACK FOOTER //
// ./src/store/errors.js